// GENERATED from pysrc/prelude.py - Python helpers that are added in front of the user's code (plot, signals, backtest_stats...).
export const PYTHON_PRELUDE = String.raw`# ---- Lightweight Terminal helpers (added automatically before your code) ----------------------------------------
# plot(name, values, pane="price", color=None)  draw a line on the chart; values = one number per candle
# signals(entries, exits)                        buy / sell arrows where a True/False list or Series is True
# buy(where, text) / sell(where, text)           one arrow; where = candle index or unix time
# backtest_stats(close, position)                prints a small report and draws the equity curve
import json as _lwt_json


class _LwtChart:
    def __init__(self):
        self.series = []
        self.markers = []


_lwt_chart = _LwtChart()


def _lwt_list(values):
    if hasattr(values, "tolist"):
        values = values.tolist()
    return list(values)


def plot(name, values, pane="price", color=None):
    """Draw a line on the chart. values: one number per candle (list, pandas Series or numpy array); NaN is skipped.
    pane: "price" = on top of the candles, "oscillator" = in its own pane below."""
    vals = _lwt_list(values)
    if len(vals) != len(candles):
        raise ValueError("plot('%s'): got %d values but there are %d candles (one value per candle)" % (name, len(vals), len(candles)))
    points = []
    for candle, value in zip(candles, vals):
        try:
            number = float(value)
        except (TypeError, ValueError):
            continue
        if number != number or number in (float("inf"), float("-inf")):
            continue
        points.append({"time": candle["time"], "value": number})
    if len(_lwt_chart.series) >= 12:
        return
    _lwt_chart.series.append({
        "name": str(name)[:40],
        "pane": "oscillator" if str(pane).lower() in ("osc", "oscillator", "separate", "below") else "price",
        "color": color,
        "data": points,
    })


def marker(where, side="buy", text=""):
    """One arrow on the chart. where: candle index (0, 1, 2 ...) or unix time in seconds."""
    if isinstance(where, (int, float)) and where < 10 ** 9:
        index = int(where)
        if index < 0:
            index += len(candles)
        if not 0 <= index < len(candles):
            return
        when = candles[index]["time"]
    else:
        when = int(where)
    if len(_lwt_chart.markers) < 2000:
        _lwt_chart.markers.append({"time": when, "side": "sell" if str(side).lower() == "sell" else "buy", "text": str(text)[:12]})


def buy(where, text=""):
    marker(where, "buy", text)


def sell(where, text=""):
    marker(where, "sell", text)


def signals(entries=None, exits=None):
    """Buy arrows where 'entries' is True and sell arrows where 'exits' is True (one True/False per candle)."""
    for flags, side in ((entries, "buy"), (exits, "sell")):
        if flags is None:
            continue
        for index, flag in enumerate(_lwt_list(flags)):
            if flag is True or (flag == flag and flag not in (None, False, 0, 0.0) and str(flag) not in ("nan", "<NA>")):
                marker(index, side)


def backtest_stats(close, position, bars_per_year=None, show=True):
    """Simple long/short backtest. position: 1 = long, -1 = short, 0 = flat, one value per candle, decided on that
    candle's close and held over the NEXT candle (no look-ahead). No fees or slippage are included."""
    import pandas as pd

    close = pd.Series(_lwt_list(close), dtype="float64")
    position = pd.Series(_lwt_list(position), dtype="float64").fillna(0.0)
    returns = close.pct_change().fillna(0.0)
    strategy = position.shift(1).fillna(0.0) * returns
    equity = (1.0 + strategy).cumprod()
    buy_hold = (1.0 + returns).cumprod()
    drawdown = equity / equity.cummax() - 1.0

    trade_id = (position != position.shift(1)).cumsum()
    trade_returns = []
    for _, group in strategy.groupby(trade_id):
        if position.loc[group.index[0]] != 0:
            trade_returns.append(float((1.0 + group).prod() - 1.0))
    wins = [r for r in trade_returns if r > 0]
    result = {
        "return_pct": round(float(equity.iloc[-1] - 1.0) * 100, 2),
        "buy_hold_pct": round(float(buy_hold.iloc[-1] - 1.0) * 100, 2),
        "max_drawdown_pct": round(float(drawdown.min()) * 100, 2),
        "trades": len(trade_returns),
        "win_rate_pct": round(len(wins) / len(trade_returns) * 100, 1) if trade_returns else 0.0,
        "avg_trade_pct": round(sum(trade_returns) / len(trade_returns) * 100, 3) if trade_returns else 0.0,
    }
    if show:
        print("Backtest (no fees, no slippage, signal acts on the next candle)")
        print("  Strategy return : %8.2f %%    (buy & hold %.2f %%)" % (result["return_pct"], result["buy_hold_pct"]))
        print("  Max drawdown    : %8.2f %%" % result["max_drawdown_pct"])
        print("  Trades          : %8d      win rate %.1f %%, average trade %.3f %%" % (result["trades"], result["win_rate_pct"], result["avg_trade_pct"]))
        print("  Past results do not predict future results.")
    plot("Equity (1.0 = start)", equity.tolist(), pane="oscillator", color="#f59e0b")
    return result


def _lwt_export():
    return _lwt_json.dumps({"series": _lwt_chart.series, "markers": _lwt_chart.markers})
`;
